import { useEffect, useState } from "react";
import { SUBJECT_DETAIL } from "../../constants/PageTitleConstants";
import SubjectDetailHeader from "./SubjectDetailHeader";
import Slider from "../homepage/Slider";
import SubjectContent from "./SubjectContent";
import {
  LOAD_MORE_BOOKS,
  SUBJECT_DETAIL_URL,
} from "../../constants/APIEndpointConstants";
import { makeGetRequest } from "../../rest/RestService";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Loader } from "../general/Loader";
import { breadCrumbHelper } from "../../helper/BreadCrumbHelper";
import { Helmet } from "react-helmet";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useHistory } from "react-router";
import { ManageScroll } from "../../helper/ManageScroll";
import PageNotFound from "../not-found/PageNotFound";

const SubjectDetail = () => {
  const location = useLocation();
  const history = useHistory();
  const [response, setResponse] = useState({});
  const { code, error } = useSelector((state) => state.geolocation);
  const { hfData, error: hfError } = useSelector((state) => state.hfReducer);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    const makeRequest = async () => {
      setLoader(true);
      const query = new URLSearchParams(location.search);
      const subjectDetailURL = `${SUBJECT_DETAIL_URL}/${code}/${query.get(
        "subject_slug"
      )}`;
      makeGetRequest(subjectDetailURL)
        .then((res) => setResponse(res.data))
        .catch((err) => setResponse({ error: err.message }))
        .finally(() => {
          setLoader(false);
          ManageScroll(history);
        });
    };
    if (code && hfData?.header) {
      makeRequest()
    }
  }, [location.search, code, history, hfData?.header]);
  const crumb = breadCrumbHelper(
    response?.subject_header,
    new URLSearchParams(location.search)
  );
  const ogURL = `${process.env.REACT_APP_FRONT_URL}${location.pathname}${location.search}`;
  const ogImage = process.env.REACT_APP_POLITY_IMAGE;
  const description = response?.subject_header?.subject_description_all;
  const pinTitleString = `${description?.replace(/(<([^>]+)>)/ig, '')}`;
  return (
    <>
      {loader ? (
        <Loader />
      ) : !response?.subject_header?.code && !error && !hfError ? (
        <>
          <Helmet>
            <title>{SUBJECT_DETAIL}</title>
            <meta property="og:type" content="website" />
            <meta property="og:title" content={response?.subject_header?.subject_name} />
            <meta property="og:url" content={ogURL} />
            <meta property="og:image" content={response?.subject_header?.image || ogImage} />
            <meta property="og:image:secure_url" content={response?.subject_header?.image || ogImage} />
            <meta property="og:image:alt" content={pinTitleString?.split('.')?.[0]} />
            <meta property="og:description" content={pinTitleString}></meta>
            <meta name="description" content={pinTitleString}></meta>
            <meta property="og:site_name" content="Polity" />
          </Helmet>
          <Header data={hfData} />
          <SubjectDetailHeader header={response.subject_header} />
          {!response.highlights?.data ? (
            <Slider data={response.highlights} crumb={crumb} />
          ) : null}
          <SubjectContent
            data={response}
            url={LOAD_MORE_BOOKS}
            title={
              response.subject_header.parent_subject_name ??
              response.subject_header.subject_name
            }
            crumb={crumb}
          />
          <Footer data={hfData} />
        </>
      ) : (
        <>
          <PageNotFound pageError={response?.error || hfError || error} />
        </>
      )}
    </>
  );
};

export default SubjectDetail;
